export function camelCase(dashedName: string) {
  return dashedName.replace(/-\w/g, replaceMatchWithUpperCaseOfSecondLetter)
}

function replaceMatchWithUpperCaseOfSecondLetter(_match: any, offset: number, fullString: string) {
  return fullString[offset + 1].toUpperCase()
}
